












































import { Vue, Prop, Component } from "vue-property-decorator";
import { Employee as IEmployee } from "@/api/models/employee";
import { EmployeeEdit as IEmployeeEdit } from "@/api/models/employee-edit";
import { User as IUser } from "@/api/models/user";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { bookkeepingModule } from "@/plugins/modules-detect";

@Component
export default class EmployeeRoles extends Vue {
  @Prop() companyUserOwner?: IUser;
  @Prop() employee!: IEmployee;
  @Prop() companyId!: string;
  showSettings: boolean = false;
  value: Array<string> = [];

  get root() {
    return isRoot();
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany;
  }

  get companyOwner() {
    let result: boolean = false;
    if (this.selectedCompany.id === this.companyId) {
      if (this.selectedCompany.owner.id === this.userId) result = true;
    }
    return result;
  }

  get userId() {
    return getCurrentUserId();
  }

  get checkBookkeepingBundle() {
    return bookkeepingModule();
  }

  get checkOwner() {
    return this.employee?.user?.id === this.companyUserOwner?.id;
  }

  getRole(role: string) {
    let formattedRole = "";
    if (role === "content_manager")
      formattedRole = this.$tc(this.$translate.Teacher);
    if (role === "learning_request_manager")
      formattedRole = `${this.$tc(this.$translate.LearningRequestManager)}`;
    if (role === "document_manager")
      formattedRole = `${this.$tc(this.$translate.Accountant)}`;
    return formattedRole;
  }

  save() {
    let deleteArray: Array<string> = [];
    let newArray: Array<string> = [];
    this.employee.roles.forEach(element => {
      if (!this.value.includes(element)) {
        deleteArray.push(element);
      }
    });

    this.value.forEach(element => {
      if (!this.employee.roles.includes(element)) {
        newArray.push(element);
      }
    });

    let params: IEmployeeEdit = {
      removeRoles: deleteArray.length > 0 ? deleteArray : undefined,
      roles: newArray.length > 0 ? newArray : undefined
    };
    api.EmployeeApi.edit(this.companyId, this.employee.id, params)
      .then(() => {
        this.showSettings = false;
        this.$emit("updateEmployees");
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  mounted() {
    this.value = [...this.value, ...this.employee?.roles];
  }
}
